export default "__VITE_PUBLIC_ASSET__eed84ac2__"